<template>
    <div>
        <ResourcesActionItemsBlock four-cols :items="items" />
    </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'

import { skillTypeDict } from '#shared/types/dictionary'
import { SkillType, type Skill } from '#shared/types/Skill'
import type { ResourcesActionItemsBlockType } from '@/components/common/ResourcesActionItemsBlock.vue'
import { useSkills } from '@/composables/skills/useSkills'

const props = defineProps<{
    skill: Skill
}>()

const { formatSkillDate } = useSkills()
const items = ref<ResourcesActionItemsBlockType>([])

const isEvent = computed((): boolean => {
    return props.skill.type === SkillType.event
})

const isWorkgroup = computed((): boolean => {
    return props.skill.type === SkillType.workgroup
})

const isStudyOpportunity = computed((): boolean => {
    return props.skill.type === SkillType.studyOpportunity
})

function getDateLabel() {
    if (isEvent.value) {
        return `Dátum${props.skill.time ? ' a čas' : ''} eventu`
    } else if (isWorkgroup.value) {
        return `Dátum${props.skill.time ? ' a čas' : ''} uzatvorenia prihlášok`
    } else if (isStudyOpportunity.value) {
        return 'Uzávierka prihlášok'
    }
    return 'Dátum'
}

// Initialize items
items.value = items.value.concat({
    icon: 'cooperation-48',
    title: 'Typ vzdelávania',
    subTitle: skillTypeDict[props.skill.type as SkillType] || 'Iné'
})

if (props.skill.startDate && props.skill.type !== SkillType.kurz) {
    items.value = items.value.concat({
        icon: 'calendar-48',
        title: getDateLabel(),
        subTitle: formatSkillDate(props.skill)
    })
}

if (props.skill.author) {
    items.value = items.value.concat({
        icon: 'cooperation-48',
        title: isWorkgroup.value ? 'Ambasádor/ka' : 'Autor',
        subTitle: props.skill.author
    })
}
</script>
